import { useCallback } from 'react';
import { Button } from 'antd';
import { Eye as EyeIcon, Rocket as RocketIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { exitDemoMode } from '@/store/authSlice';
import { exitDemo } from './seedDemoStore';
import './demo.css';

/**
 * Sticky read-only demo banner. Rendered by AppLayout whenever `auth.isDemo` is
 * true. Amber (#fbbf24) per SSP branding. The primary CTA tears down the demo
 * (clearing the tab-scoped sessionStorage flag + the fixture adapter) and routes
 * to /login to start a real org (§10.5).
 */
export function DemoBanner() {
  const isDemo = useAppSelector((state) => state.auth.isDemo);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleStartReal = useCallback(() => {
    exitDemo();
    dispatch(exitDemoMode());
    void navigate('/login');
  }, [dispatch, navigate]);

  if (!isDemo) return null;

  return (
    <div className="demo-banner" role="status" aria-live="polite">
      <span className="demo-banner-badge font-display">
        <EyeIcon aria-hidden /> {t('demo.bannerBadge')}
      </span>
      <span className="demo-banner-text">{t('demo.bannerText')}</span>
      <Button
        type="primary"
        size="small"
        icon={<RocketIcon />}
        className="demo-banner-cta"
        onClick={handleStartReal}
      >
        {t('demo.startRealOrg')}
      </Button>
    </div>
  );
}

export default DemoBanner;
